import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import { actionTypes, apiStatuses, CheckDuplicateAndQuarantine, checkDuplicateAndQuarantineDeferred } from "./Actions";

const checkDuplicateAndQuarantine: CheckDuplicateAndQuarantine = (
  productId,
  owningClient,
  spidId,
  sig
) => dispatch => {
  const failedCallback = (data: any) => {
    dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.CHECK_DUPLICATE_AND_QUARANTINE
    });
    return checkDuplicateAndQuarantineDeferred.reject(data);
  };
  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.CHECK_DUPLICATE_AND_QUARANTINE
  });

  fetchWithUuid(
    `/bestilling/c/${owningClient}/api/v2/ff/users/${spidId}/${productId}/isDuplicate.json`,
    {
      headers: {
        'x-score-spid-sig': sig
      }
    }
  )
    .then(checkError)
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.CHECK_DUPLICATE_AND_QUARANTINE
      });
      return checkDuplicateAndQuarantineDeferred.resolve(data);
    })
    .catch(failedCallback);

  return checkDuplicateAndQuarantineDeferred.promise;
};

export default checkDuplicateAndQuarantine;
